import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { ProvinceTaskGetter } from '@/store/provinceTask/provinceTask.module';
import { ProvinceTask, ProvinceTaskAttachment } from '@/store/provinceTask/provinceTask.model';
import BaseOffcanvasComponent from '@/components/baseOffcanvas/BaseOffcanvas.vue';

export default defineComponent({
  name: 'ProjectAttachmentOffcanvasComponent',
  components: {
    BaseOffcanvasComponent
  },
  props: {
    provinceTaskId: {
      type: Number,
    },
  },
  setup: (props) => {
    const store = useStore();
    const provicneTask = computed<ProvinceTask | undefined>(() => store.getters[ProvinceTaskGetter.BY_ID](props.provinceTaskId));
    const attachments = computed<ProvinceTaskAttachment[]>(() => (provicneTask.value) ? provicneTask.value?.provinceTaskAttachments.filter(m => m.attachmentType.id === 1) : []);
    const images = computed<ProvinceTaskAttachment[]>(() => (provicneTask.value) ? provicneTask.value?.provinceTaskAttachments.filter(m => m.attachmentType.id === 2) : []);
    const attachmentOffcanvas = ref<InstanceType<typeof BaseOffcanvasComponent>>();

    // show modal
    const show = () => {
      attachmentOffcanvas.value?.show();
    };

    // hide modal
    const hide = () => {
      attachmentOffcanvas.value?.hide();
    };

    const attachmentClick = (url: string) => {
      window.open(url, '_blank');
    };

    return {
      attachments,
      images,
      attachmentOffcanvas,
      show,
      hide,
      attachmentClick,
    };
  }
});
